import React from 'react';
import ChatInterface from '../ChatInterface/ChatInterface';
import styles from './Header.module.css';

const SalesConciergeHeader = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.waveBackground}></div>
        <div className={styles.contentWrapper}>
          <div className={styles.contentBox}>
            <div className={styles.textContent}>
              <h1 className={styles.heading1}>Transform</h1>
              <h2 className={styles.heading2}>Guest Communication</h2>
              <h3 className={styles.heading3}>with AI Sales Concierge</h3>
            </div>
            <p className={styles.description}>
              Instant, intelligent chat & voice support that engages guests,
              builds confidence, and helps you convert more bookings with ease.
            </p>
          </div>
          <div className={styles.phoneWrapper}>
            <div className={styles.phoneMockup}>
              <ChatInterface />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesConciergeHeader;
